import React, { FC } from 'react'
import { makeStyles } from '@mui/styles'

import spinner from '../../../images/spinner.gif'

const useStyles = makeStyles(({ palette }) => ({
  preloader: {
    width: 'calc(100% - 60px)',
    height: 'calc(100% - 60px)',
    background: palette.background.default,
    position: 'absolute',
    zIndex: 1001,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& img': {
      margin: '0 auto',
      width: '60px',
      height: '60px',
    },
  },
}))

const Preloader: FC = () => {
  const classes = useStyles()
  return (
    <div className={classes.preloader}>
      <img alt="Loading..." src={spinner} />
    </div>
  )
}

export default Preloader
